export const extractFields = (items = [], field = 'id') =>
	items.map(item => item?.[field])
